import React from 'react'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap'
import FormCard from '../common/FormCard'

function UsersEditCard({
  editingUser,
  editData,
  editErrors,
  editSubmitted,
  isUpdating,
  editMessage,
  onChange,
  onSubmit,
  onCancel,
}) {
  if (!editingUser) {
    return null
  }

  return (
    <FormCard
      title="Editar usuario"
      onSubmit={onSubmit}
      onCancel={onCancel}
      submitLabel="Guardar cambios"
      showCancel
      isSubmitting={isUpdating}
      errorMessage={editMessage && !editMessage.includes('correctamente') ? editMessage : ''}
      successMessage={editMessage && editMessage.includes('correctamente') ? editMessage : ''}
    >
      <FormGroup>
        <Label for="edit-username">Usuario</Label>
        <Input
          type="text"
          id="edit-username"
          value={editingUser.username || ''}
          disabled
        />
      </FormGroup>
      <FormGroup>
        <Label for="edit-role">
          Rol <span className="text-danger">*</span>
        </Label>
        <Input
          type="select"
          name="role"
          id="edit-role"
          value={editData.role}
          onChange={onChange}
          invalid={editSubmitted && !!editErrors.role}
        >
          <option value="ADMIN">Admin</option>
          <option value="WHOLESALER">Mayorista</option>
          <option value="DISTRIBUTOR">Distributor</option>
        </Input>
        {editSubmitted && editErrors.role && (
          <FormFeedback>{editErrors.role}</FormFeedback>
        )}
      </FormGroup>
      {editData.role === 'WHOLESALER' && (
        <FormGroup>
          <Label for="edit-wholesaler">Mayorista</Label>
          <Input
            type="text"
            name="wholesaler"
            id="edit-wholesaler"
            placeholder="Nombre del wholesaler"
            value={editData.wholesaler}
            onChange={onChange}
          />
        </FormGroup>
      )}
      <FormGroup>
        <Label for="edit-password">Nueva contraseña</Label>
        <Input
          type="password"
          name="password"
          id="edit-password"
          placeholder="Dejar en blanco para no cambiar"
          value={editData.password}
          onChange={onChange}
        />
      </FormGroup>
    </FormCard>
  )
}

export default UsersEditCard
